import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 20H3C2.45 20 2 19.55 2 19V5C2 4.45 2.45 4 3 4H21C21.55 4 22 4.45 22 5V19C22 19.55 21.55 20 21 20ZM4 18H20V6H4V18Z" fill={ fill || 'currentColor' } />
        <path d="M10.465 9.01001L10.4602 9.01004C10.5581 9.01106 10.6466 9.04122 10.735 9.11001L13.835 11.6C14.085 11.8 14.085 12.18 13.835 12.38L10.745 14.88C10.655 14.95 10.555 14.98 10.465 14.98C10.225 14.98 9.995 14.78 9.995 14.48V9.51001C9.995 9.21202 10.2219 9.0127 10.4602 9.01004L10.455 9.01001H10.465Z" fill={ fill || 'currentColor' } />
    </svg>
);
